import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import Layout from './layout/Layout';
import ShipmentListPage from './pages/ShipmentListPage';
import ShipmentDetailPage from './pages/ShipmentDetailPage';
import AccountSettingsPage from './pages/AccountSettingsPage';

const App: React.FC = () => (
  <BrowserRouter>
    <AuthGuard>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/shipments/list" replace />} />
          <Route path="shipments/list" element={<ShipmentListPage />} />
          <Route path="shipments/:shipmentId" element={<ShipmentDetailPage />} />
          <Route path="settings/account" element={<AccountSettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthGuard>
  </BrowserRouter>
);

export default App;
